
//import ConstUtils from '@/utils/ConstUtils.js';
//import MapUtils from '@/utils/MapUtils.js';

export default class LabelOperations {
  static PARAMS = 'Params';

  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }

  contains(name) {
    if (name) {
      //
    }
    return false;
  }

  save(params) {
    var event = new LabelOperations.Save.Request(params);
    var wrappedEvent = this.eventsDomain.initRequest(event);
    return wrappedEvent;
  }

  static Save = {
    Names: {
      Operation: 'LabelSaveCommandOperation',
      Notification: 'LabelNotification',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Request: function (params) {
      var event = {
        handler: LabelOperations.Save.Names.Operation,
        eventName: LabelOperations.Save.Names.Operation,
      }
      event[LabelOperations.PARAMS] = params.data ? params.data : params;
      return event
    },
  }

  list(params) {
    var event = new LabelOperations.List.Operation(params);
    var wrappedEvent = this.eventsDomain.initRequest(event);
    return wrappedEvent;
  }

  static List = {
    Names: {
      Operation: 'LabelListQueryOperation',
      Notification: 'LabelNotification',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Operation: function (params) {
      var event = {
        handler: LabelOperations.List.Names.Operation,
        eventName: LabelOperations.List.Names.Operation,
      }
      event[LabelOperations.PARAMS] = params.data ? params.data : params;
      return event;
    },
  }

}